<div class="main-content">
  <div class="container-fluid">

    <div style="float: right; margin-right: 20px" class="row">
      <!-- <button (click)="openModal('create')" mat-raised-button class="btn btn-success">
        <span class="btn-label">
          <i class="material-icons">add</i>
        </span>
        New category
      </button> -->
    </div>

    <div class="clearfix"></div>

    <div class="card">

      <div class="card-header card/-header-primary card-header-icon">
        <div class="card-icon">
          <i class="material-icons">assignment</i>
        </div>
        <h4 class="card-title">List Uneda Inventory </h4>
      </div>

      <div class="card-body">
        <div *ngIf="this.companyFather.unedaType == 'IQ'">
           <div class="alert alert-danger">Your inventory is on IQ</div>
        </div>
        <div *ngIf="this.companyFather.unedaType == 'INVENTORY'" class="material-datatables" style="width:100%">
          <mat-progress-bar style="width: 80%" *ngIf="loading" id="loadingbar" mode="indeterminate"></mat-progress-bar>
          <table id="datatable" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%" style="width:100%">
                  <thead>
                    <tr>
                      <th>{{ data.headerRow[0] }}</th>
                      <th>{{ data.headerRow[1] }}</th>
                      <th>{{ data.headerRow[2] }}</th>
                 
                      <!-- <th class="text-right">Actions</th> -->
                    </tr>
                </thead>
                <tfoot>
                  <tr>
                    <th>{{ data.footerRow[0] }}</th>
                    <th>{{ data.footerRow[1] }}</th>
                    <th>{{ data.footerRow[2] }}</th>
                   
                    <!-- <th class="text-right">Actions</th> -->
                  </tr>
                </tfoot>
                <tbody>
                  <tr *ngFor="let row of data.dataRows">
                    <td>{{row[0]}}</td>
                    <td>{{row[1]}}</td>
                    <td>{{row[2]}}</td>
                    <!-- <td>{{row[3] * 1000 | date:'MM-dd-yyyy'}}</td>
                     <td class="text-right">
                      <a class="btn btn-link btn-info btn-just-icon like" (click)="saveEmit('read',row[0], row)"><i class="material-icons">remove_red_eye</i></a>
                      <a class="btn btn-link btn-danger btn-just-icon" (click)="saveEmit('delete',row[0], row)"><i class="material-icons">close</i></a>
                    </td> -->
                </tr>
                </tbody>
            </table>
            <input type="hidden" name="borrarContact" value="" id="borrarContact">
        </div>
      </div>

    </div>

  </div>
</div>
